import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { getAllReferrals } from '../../services/referralService';

const PageContainer = styled.div`
  padding: 2rem;
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 2rem;
`;

const FiltersContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
`;

const Input = styled.input`
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const Select = styled.select`
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  
  th, td {
    border: 1px solid #e0e0e0;
    padding: 12px;
    text-align: left;
  }
  
  th {
    background: #f9f9f9;
  }
`;

const ReferralsPage = () => {
  const [referrals, setReferrals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    referrer: '',
    referred: '',
    date: '',
    reward_given: '',
  });

  useEffect(() => {
    const fetchReferrals = async () => {
      try {
        const data = await getAllReferrals(filters);
        setReferrals(data);
      } catch (err) {
        setError(err.message || 'Failed to fetch referrals');
      } finally {
        setLoading(false);
      }
    };

    fetchReferrals();
  }, [filters]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <PageContainer>
      <Title>Referrals</Title>
      <FiltersContainer>
        <Input
          type="text"
          name="referrer"
          placeholder="Filter by referrer"
          value={filters.referrer}
          onChange={handleFilterChange}
        />
        <Input
          type="text"
          name="referred"
          placeholder="Filter by referred user"
          value={filters.referred}
          onChange={handleFilterChange}
        />
        <Input
          type="date"
          name="date"
          value={filters.date}
          onChange={handleFilterChange}
        />
        <Select name="reward_given" value={filters.reward_given} onChange={handleFilterChange}>
          <option value="">All Rewards</option>
          <option value="true">Reward Given</option>
          <option value="false">Reward Not Given</option>
        </Select>
      </FiltersContainer>
      <Table>
        <thead>
          <tr>
            <th>Referrer</th>
            <th>Referred User</th>
            <th>Sign-up Date</th>
            <th>Conversion Status</th>
            <th>Reward Status</th>
          </tr>
        </thead>
        <tbody>
          {referrals.map(r => (
            <tr key={r._id}>
              <td>{r.referrer.name || r.referrer.email}</td>
              <td>{r.referred.name || r.referred.email}</td>
              <td>{new Date(r.createdAt).toLocaleDateString()}</td>
              <td>{r.status}</td>
              <td>{r.reward_earned ? 'Earned' : 'Pending'}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </PageContainer>
  );
};

export default ReferralsPage;
